<template>
  <div id="app">
    <SipremWeb/>
  </div>
</template>

<script>
import SipremWeb from './components/SipremWeb.vue'


export default {
  name: 'app',
  components: {
    SipremWeb
  }
}
</script>

<style>
</style>
